import classnames from 'classnames';
import { FC, useState } from 'react';
import Icon from '@/components/Icon';
import styles from './index.less';

const subCategoryContainerWidth = 1192;
const subCategoryGapWidth = 48;

const NavItem: FC<{
  url: string;
  name: string;
  subCategoryList: any[];
  isScrollTopZero?: boolean;
  categoryId: string | number;
  subCategoryTopPosition: number;
}> = ({
  url,
  name = '',
  categoryId,
  isScrollTopZero,
  subCategoryList = [],
  subCategoryTopPosition,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const list = subCategoryList || [];
  const max = Math.ceil(list?.length / 5);

  const onSlideNext = () => {
    if (activeIndex < max - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const onSlidePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const showNextSlideIcon = activeIndex < max - 1;
  const showPrevSlideIcon = activeIndex > 0;
  const isMoreThanOnePage = list?.length > 5;
  const isShowSubCategoryList = list?.length > 0;
  const transform = `translateX(-${
    activeIndex * (subCategoryContainerWidth + subCategoryGapWidth)
  }px)`;

  return (
    <li
      className={classnames(
        `cursor-pointer flex items-center relative`,
        isScrollTopZero ? 'px-[30px]' : 'px-[20px]',
        styles.warp,
        styles.navItem,
      )}
    >
      <span
        className={classnames(
          `text-[#121212] relative leading-[50px]
          max-w-[130px] limit-rows1`,
          styles.navItemText,
        )}
        onClick={() => {
          window.open(`${url}${categoryId}`, '_self');
        }}
      >
        {name}
      </span>
      {isShowSubCategoryList && (
        <div
          className={classnames(
            `fixed flex items-center justify-center
          w-[100vw] left-0 bg-[#ffffff]`,
            styles.subCategoryList,
          )}
          style={{ top: `${subCategoryTopPosition}px` }}
        >
          <span
            onClick={onSlidePrev}
            className={classnames(
              'h-[32px] w-[32px] mt-[-52px]',
              showPrevSlideIcon ? 'block' : 'opacity-0',
            )}
          >
            <Icon
              type="icon-iocn_jiantou2"
              className="text-[32px] text-[#333333] rotate-180"
            />
          </span>
          <div
            className="overflow-hidden mx-[32px]"
            style={{ width: `${subCategoryContainerWidth}px` }}
          >
            <div
              className={classnames(
                `flex items-center gap-x-[48px]`,
                isMoreThanOnePage ? 'justify-start' : 'justify-center',
                styles.animate,
              )}
              style={{
                transform: transform,
              }}
            >
              {list?.map((item) => {
                const { categoryId, id, image } = item;
                return (
                  <div
                    key={item.categoryId}
                    className="flex flex-col items-center justify-center gap-y-[24px] py-[40px]"
                    onClick={() =>
                      window.open(`${url}${categoryId || id}`, '_self')
                    }
                  >
                    <div
                      className={classnames(
                        'w-[200px] h-[200px] rounded-[100px] relative',
                        styles.imageBox,
                      )}
                    >
                      <img
                        className={classnames(
                          'w-[200px] h-[200px] rounded-[100px] object-cover',
                        )}
                        src={
                          image ||
                          'http://file.meilisci.com/1723632500487_%E7%BC%96%E7%BB%843.png'
                        }
                      />
                    </div>
                    <span>{item.name}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <span
            onClick={onSlideNext}
            className={classnames(
              'h-[32px] w-[32px] mt-[-52px]',
              showNextSlideIcon ? 'block' : 'opacity-0',
            )}
          >
            <Icon
              type="icon-iocn_jiantou2"
              className="text-[32px] text-[#333333]"
            />
          </span>
        </div>
      )}
    </li>
  );
};

export default NavItem;
